import type { ReactNode } from 'react';
import { Header } from '@/components/header/Header';
import { StatusBar } from '@/components/status-bar/StatusBar';

interface ShellProps {
  children: ReactNode;
}

export const Shell = ({ children }: ShellProps) => (
  <div className="flex h-screen flex-col bg-background text-foreground">
    <Header />
    <main className="flex min-h-0 flex-1 bg-surface-sunken">{children}</main>
    <StatusBar />
  </div>
);
